import React, { useEffect } from 'react';

import { FlexLayout } from '@swyftx/aviary/atoms/Layout/Flex';

import { Outlet } from 'react-router';
import { useIntercom } from 'react-use-intercom';
import { useSwyftxMargin, useSwyftxMarginStore } from 'src/lib/margin';
import { useInitMarginAccount } from 'src/lib/margin/hooks/account/useInitMarginAccount';
import { useNavigateRoute } from 'src/lib/navigation/hooks';
import { NavigationURLs } from 'src/lib/navigation/types';

import { SwyftxMarginAppShellMaintenance } from './SwyftxMarginAppShellMaintenance';
import { SwyftxMarginAppHeader, SwyftxMarginAppShellMobileMenu, SwyftxMarginAppContent } from './components';
import { useLayoutStore, useLoadingPlatform } from '../hooks';

const SwyftxMarginAppShell: React.FC = () => {
  const { mobileMenuOpen, setMobileMenuOpen } = useLayoutStore();
  useInitMarginAccount();

  const { isUnderMaintenance } = useSwyftxMargin();
  const { traderAccountId } = useSwyftxMarginStore();
  const { navigate } = useNavigateRoute();
  const { update } = useIntercom();

  useLoadingPlatform();

  useEffect(() => {
    if (!traderAccountId) {
      navigate(NavigationURLs.Dashboard);
    }
  }, [navigate, traderAccountId]);

  useEffect(() => {
    update({
      hideDefaultLauncher: true,
    });

    return () => {
      update({
        hideDefaultLauncher: false,
      });
    };
  }, [update]);

  if (!traderAccountId) return null;

  return (
    <FlexLayout className='h-full w-full overflow-hidden'>
      <SwyftxMarginAppShellMobileMenu mobileMenuOpen={mobileMenuOpen} setMobileMenuOpen={setMobileMenuOpen} />
      <SwyftxMarginAppContent mobileMenuOpen={mobileMenuOpen} setMobileMenuOpen={setMobileMenuOpen}>
        <SwyftxMarginAppHeader mobileMenuOpen={mobileMenuOpen} setMobileMenuOpen={setMobileMenuOpen} />
        {isUnderMaintenance ? <SwyftxMarginAppShellMaintenance /> : <Outlet />}
      </SwyftxMarginAppContent>
    </FlexLayout>
  );
};

export { SwyftxMarginAppShell };
